import type { ReactElement } from 'react';

import styles from './fields.module.css';

export function FormError({ message }: { message: string | null }): ReactElement | null {
    if (message === null || message.length === 0) {
        return null;
    }
    return (
        <p role="alert" className={styles.formError}>
            {message}
        </p>
    );
}
